import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import React from 'react';
import styles from '../../Policies/Summary/Summary.module.scss';
import metadata from './CoveragesTermsIterableComponent.metadata.json5';

function CoveragesTermsIterableComponent(props) {
    const { data: termsData } = props;

    const resolvers = {
        resolveClassNameMap: styles,
    };

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={termsData}
            classNameMap={resolvers.resolveClassNameMap}
            overrideProps={overrideProps}
        />
    );
}

CoveragesTermsIterableComponent.propTypes = {
    data: PropTypes.shape({}).isRequired,
};

export default CoveragesTermsIterableComponent;
